<template>
  <div>
    <div class="news-container">
      <header class="page-header">
        <h1 class="section-title">禾销新闻动态 - 导购激励最新资讯</h1>
        <p class="page-description">获取禾销平台在导购激励政策、费用核销、动销数据方面的最新动态和行业见解。</p>
      </header>
      
      <section class="news-list-section">
        <div class="news-list">
          <article class="news-item" v-for="news in newsList" :key="news.id" 
                   @click="navigateToNewsDetail(news.id)">
            <div class="news-content">
              <h2 class="news-title">{{ news.title }}</h2>
              <p class="news-summary">{{ news.summary }}</p>
              <div class="news-keywords">
                <span class="keyword-tag">导购激励</span>
                <span class="keyword-tag">费用核销</span>
                <span class="keyword-tag">动销数据</span>
              </div>
            </div>
          </article>
        </div>
      </section>
      
      <div class="pagination">
        <button class="btn btn-outline-primary" :disabled="currentPage === 1">上一页</button>
        <span class="page-info">{{ currentPage }} / {{ totalPages }}</span>
        <button class="btn btn-outline-primary" :disabled="currentPage === totalPages">下一页</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutNews',
  data() {
    return {
      activeTab: 'news',
      currentPage: 1,
      totalPages: 1,
      newsList: [
        
        {
          id: 2,
          // date: '2023-05',
          title: '禾销导购激励平台服务门店突破4万家，导购员超10万',
          summary: '禾销平台业务快速增长，已服务全国40000+母婴、美妆门店，覆盖10万+零售导购员，成为行业领先的导购激励政策落地工具。'
        },
        {
          id: 1,
          // date: '2019-12',
          title: '禾销平台正式上线：重新定义导购激励政策落地方式',
          summary: '禾销智能导购激励平台成功发布，为零售品牌提供导购激励政策定制、费用核销与动销数据一体化解决方案。'
        }
      ]
    }
  },
  methods: {
    navigateToNewsDetail(id) {
      // 跳转到新闻详情页
      this.$router.push(`/about/news/${id}`)
    },
    formatDate(date) {
      // 格式化日期为YYYY-MM-DD
      return date + '-01' // 假设都是月初
    }
  }
}
</script>

<style scoped>
.news-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

/* 页面头部样式 */
.page-header {
  margin-bottom: 30px;
  text-align: center;
}

.section-title {
  color: #333;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 15px;
  line-height: 1.4;
}

.page-description {
  color: #666;
  font-size: 16px;
  line-height: 1.6;
  max-width: 800px;
  margin: 0 auto;
}

/* 新闻列表区块样式 */
.news-list-section {
  margin-top: 30px;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 25px;
  margin-bottom: 40px;
}

/* 新闻项样式 */
.news-item {
  padding: 25px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-left: 4px solid #007bff;
}

.news-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  background-color: #f8f9fa;
}

/* 内容样式 */
.news-content {
  flex-grow: 1;
  padding-left: 0;
}

.news-title {
  color: #333;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 12px;
  line-height: 1.4;
  transition: color 0.3s ease;
}

.news-item:hover .news-title {
  color: #007bff;
}

.news-summary {
  color: #666;
  line-height: 1.6;
  font-size: 15px;
  margin: 0 0 15px 0;
}

/* 关键词标签样式 */
.news-keywords {
  margin-top: 10px;
}

.keyword-tag {
  display: inline-block;
  background: #e9ecef;
  color: #666;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  margin-right: 10px;
  margin-bottom: 8px;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.news-item:hover .keyword-tag {
  background: #007bff;
  color: white;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.page-info {
  color: #666;
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .section-title {
    font-size: 24px;
  }
  
  .page-description {
    font-size: 14px;
  }
  
  .news-item {
    padding: 20px;
    border-left: none;
    border-top: 4px solid #007bff;
  }
  
  .news-title {
    font-size: 20px;
  }
  
  .news-summary {
    font-size: 14px;
  }
  
  .keyword-tag {
    margin-right: 8px;
    margin-bottom: 6px;
  }
}
</style>